export const DEFAULT_AVATAR = 'https://static.change.org/profile-img/default-user-profile.svg';
export const DEFAULT_IMAGE = 'https://static.change.org/images/default-petition-darker.gif';
export const DEFAULT_IMAGE_LIGHT = 'https://static.change.org/images/default-petition.gif';
